"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as h } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const d = (_param)=>{
    var { color: r, size: l = 24 } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const c = h(), o = r !== null && r !== void 0 ? r : c ? i.colors.inverse : i.colors.neutralHigh, { skinName: s } = n();
    return s.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M21.168 17.382a.75.75 0 0 1 .82.617.686.686 0 0 1-.604.806l-3.805.581-.532-3.89c-.072-.401.212-.765.604-.839a.75.75 0 0 1 .82.618l.216 1.562a8.86 8.86 0 0 0 1.457-4.835c0-4.729-3.73-8.546-8.36-8.546S3.421 7.27 3.421 11.998s3.737 8.546 8.36 8.509c1.244 0 2.456-.254 3.557-.798a.754.754 0 0 1 .96.364c.14.364 0 .802-.356.982A9.7 9.7 0 0 1 11.78 22C6.374 22 2 17.529 2 12.002S6.382 2 11.784 2s9.78 4.475 9.777 9.998c0 2-.605 3.927-1.673 5.563z"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M11.072 5.453c0-.397.316-.724.708-.724.393 0 .713.327.713.728v6.246l2.633 2.692a.715.715 0 0 1 0 1.019.69.69 0 0 1-.496.22.7.7 0 0 1-.497-.22l-2.845-2.909a.72.72 0 0 1-.216-.507z"
            })
        ]
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M21.168 17.382a.75.75 0 0 1 .82.617.686.686 0 0 1-.604.806l-3.805.581-.532-3.89c-.072-.401.212-.765.604-.839a.75.75 0 0 1 .82.618l.216 1.562a8.86 8.86 0 0 0 1.457-4.835c0-4.729-3.73-8.546-8.36-8.546S3.421 7.27 3.421 11.998s3.737 8.546 8.36 8.509c1.244 0 2.456-.254 3.557-.798a.754.754 0 0 1 .96.364c.14.364 0 .802-.356.982A9.7 9.7 0 0 1 11.78 22C6.374 22 2 17.529 2 12.002S6.382 2 11.784 2s9.78 4.475 9.777 9.998c0 2-.605 3.927-1.673 5.563z"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M11.072 5.453c0-.397.316-.724.708-.724.393 0 .713.327.713.728v6.246l2.633 2.692a.715.715 0 0 1 0 1.019.69.69 0 0 1-.496.22.7.7 0 0 1-.497-.22l-2.845-2.909a.72.72 0 0 1-.216-.507z"
            })
        ]
    }));
}, u = d;
export { u as default };
